import { render, staticRenderFns } from "./BotlinkWXkefu.vue?vue&type=template&id=6ac1fc7d&scoped=true"
import script from "./BotlinkWXkefu.vue?vue&type=script&lang=js"
export * from "./BotlinkWXkefu.vue?vue&type=script&lang=js"
import style0 from "./BotlinkWXkefu.vue?vue&type=style&index=0&id=6ac1fc7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1fc7d",
  null
  
)

export default component.exports